import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-detail-file-summary',
  templateUrl: './detail-file-summary.component.html',
  styleUrls: ['../../pages/detail-file/styles/detail-file.layout.css']
})
export class DetailFileSummaryComponent {
  @Input() itinerary: any;
  @Input() dataSourcePax: any;
  /** Si es false, oculta acciones de edición (útil en OS Masivas). */
  @Input() interactive = true;

  @Output() editState = new EventEmitter<any>();
  @Output() preOperationalIncidents = new EventEmitter<any>();
}
